module.exports = __webpack_public_path__ + "static/assets/ca38c2c7658b44e276b09b04c440e3d2.png";